module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.showOnlyProgram) ? _c('div', {
    staticClass: "main-panel",
    class: {
      'main-panel--desktop-shell': !_vm.isMobile,
      'main-panel--desktop-topbar': !_vm.isMobile && _vm.desktopNavMode === 'topbar',
      'main-panel--mobile-has-bottom-bar': _vm.isMobile && _vm.isEnableBottomBar && (_vm.role === 'ROLE_USER')
    }
  }, [(_vm.isMobileAndUser) ? _c('top-navbar') : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "mobile-nav-spacer"
  }) : _vm._e(), _vm._v(" "), _c('dashboard-content', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSidebar.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.isMobile && _vm.isEnableBottomBar && (_vm.role === 'ROLE_USER')) ? _c('bottom-bar') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showOnlyProgram) ? _c('div', {
    staticClass: "main-panel"
  }, [_c('dashboard-content')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38d82418!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/MainView.vue
// module id = 757
// module chunks = 0